import React, { useState } from 'react';

import Item from 'schema/item';

interface ItemsContextProviderProps {
  children?: React.ReactNode;
}

const ItemsContext = React.createContext<{
  items: Item[];
  setItems: React.Dispatch<React.SetStateAction<Item[]>> | null;
}>({ items: [], setItems: null });

const ItemsContextProvider: React.FC<ItemsContextProviderProps> = ({
  children,
}) => {
  const [items, setItems] = useState<Item[]>([]);

  return (
    <ItemsContext.Provider value={{ items, setItems }}>
      {children}
    </ItemsContext.Provider>
  );
};

export default ItemsContextProvider;
export { ItemsContext };
